// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".def-scroll-to[data-v-51abfb0f]{color:#7b7c7e}", "",{"version":3,"sources":["webpack://./js.autoload/vueComponents/Def/DefScrollTo/DefScrollTo.vue"],"names":[],"mappings":"AAAA,gCAAe,aAEf","sourcesContent":[".def-scroll-to{color:#7b7c7e}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
